import Api from './Api';
export default {

    SendFeedback(payload) {
        return Api().post('/api/freshdesk/sendfeedback', payload)
    },

}


// WEBPACK FOOTER //
// ./src/services/FreshDeskService.js